import React from 'react'
import { StyledMaintenanceMode } from './styled'

const MaintenanceMode = ({ message }) => {
  return <StyledMaintenanceMode>{message ? message : 'Modo de mantenimiento activo'}</StyledMaintenanceMode>
}

export default MaintenanceMode
